// APVacancyApplicantList.tsx
import React from "react";
import { APActivity } from "../../../../ActivityInterfaces";
import { APOffer } from "../../../../views/details/offer-feature/APOffer.Interface";
import { VACANCY_ACCORDION_LIST_PREFIX } from "../../hooks/useVacancyActivity";
import { APOfferAccordionList } from "../../../../views/details/offer-feature/offer/offer-list/APOfferAccordionList";
import { APRouteWrapper } from "../../../../views/details/offer-feature/offer/offer-list/APRouteWrapper";
import VacancyApplicantListEntry from "./vacancy-applicant-entry/VacancyApplicantListEntry";
import { useActivityConstants } from "../../../../ActivityHooks";
import VacancyApplicantActionFlow from "../../action-flow/VacancyApplicantActionFlow";
import ActivityUtils from "@/modules/activity-components/ActivityUtils";
import VacancyOfferUtils from "../utils/VacancyOfferUtils";

type Props = {
  activity: APActivity;
};

const APVacancyApplicantList = (props: Props) => {
  const { activity } = props;

  const constants = useActivityConstants();

  const additionalStatus = {
    accepted: VacancyOfferUtils.getOfferStatusForContractMQ(),
  };
  
  return (
    <APRouteWrapper defaultStatus="incomplete">
      {({ baseUrl, activeStatus }) => (
        <div className="vacancy-applicant-list">
          <div className="padding-top-20 padding-bottom-20">
            <VacancyApplicantActionFlow
              activity={activity}
              constants={constants}
            />
          </div>
          <div className="list-accordion-wrapper __card">
            <APOfferAccordionList
              activity={activity}
              identifierPrefix={VACANCY_ACCORDION_LIST_PREFIX}
              statuses={ActivityUtils.getActivityOfferStatusKeys()}
              additionalStatus={additionalStatus}
              baseUrl={baseUrl}
              activeStatus={activeStatus}
              renderEntry={(offer: APOffer) => (
                <VacancyApplicantListEntry
                  offer={offer}
                  activity={activity}
                  constants={constants}
                  editable
                />
              )}
            />
          </div>
        </div>
      )}
    </APRouteWrapper>
  );
};

export default APVacancyApplicantList;
